import { useCallback } from 'react';
import { normalizeLatLng, setupZoomControl } from '.';

export const useMapZoomControls = () => {
    const handleZoomOutStyle = useCallback((zoom: number, map: google.maps.Map | null) => {
        const newZoom = map?.getZoom() ?? zoom;
        const zoomDiff = newZoom <= zoom - 1;

        setupZoomControl(zoomDiff);

        if (map) {
            if (zoomDiff) {
                map.setOptions({
                    gestureHandling: 'greedy',
                    minZoom: zoom - 1,
                    draggable: false
                });
            } else {
                map.setOptions({
                    gestureHandling: "auto",
                    minZoom: undefined,
                    draggable: true
                });
            }
        }

        return { isZoomed: newZoom !== zoom, zoomLevel: map?.getZoom() || 0, center: normalizeLatLng(map?.getCenter()) };
    }, []);

    const handleWheel = useCallback((event: WheelEvent, map: google.maps.Map | null) => {
        if (event.deltaY < 0 && map) {
            event.preventDefault();
            map.setOptions({
                gestureHandling: "auto",
                minZoom: undefined,
                draggable: true
            });
        }
        return { isZoomed: true, zoomLevel: map?.getZoom() || 0, center: normalizeLatLng(map?.getCenter()) };
    }, []);

    const handleTouch = useCallback((event: TouchEvent, map: google.maps.Map | null, subDistrictDefaultZoom: number) => {
        if (event.touches.length > 1) {
            const zoomDiff = (map?.getZoom() || 0) <= subDistrictDefaultZoom - 1;

            if (!zoomDiff && map) {
                event.preventDefault();
                map.setOptions({
                    gestureHandling: "auto",
                    minZoom: undefined,
                    draggable: true
                });
            }
        }
        return { isZoomed: true, zoomLevel: map?.getZoom() || 0, center: normalizeLatLng(map?.getCenter()) };
    }, []);

    const handleDragEnd = useCallback((map: google.maps.Map | null) => {
        const center = map?.getCenter();
        if (center) {
            return { lat: center.lat(), lng: center.lng() };
        }
        return null;
    }, []);

    const handleResetBound = useCallback((map: google.maps.Map | null, bounds: any, padding: number = 0) => {
        map?.fitBounds(bounds, padding);
        setupZoomControl(false);
    }, []);

    return {
        handleZoomOutStyle,
        handleWheel,
        handleTouch,
        handleDragEnd,
        handleResetBound
    };
};
